import { render, staticRenderFns } from "./ia-cliente-contratos.vue?vue&type=template&id=87059df8&scoped=true&"
import script from "./ia-cliente-contratos.vue?vue&type=script&lang=js&"
export * from "./ia-cliente-contratos.vue?vue&type=script&lang=js&"
import style0 from "./ia-cliente-contratos.vue?vue&type=style&index=0&id=87059df8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87059df8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87059df8')) {
      api.createRecord('87059df8', component.options)
    } else {
      api.reload('87059df8', component.options)
    }
    module.hot.accept("./ia-cliente-contratos.vue?vue&type=template&id=87059df8&scoped=true&", function () {
      api.rerender('87059df8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/ia-cliente-painel/ia-cliente-contratos.vue"
export default component.exports